/**
 * A câmera enxerga o mesmo QR em dezenas de quadros por segundo. Sem uma
 * trava, uma única peça entraria dezenas de vezes no carrinho — e o caixa só
 * perceberia no total.
 *
 * O portão bloqueia cada código por uma janela curta depois de liberá-lo, sem
 * bloquear os demais: escanear uma pilha de peças em sequência continua rápido.
 */

/** Tempo de bloqueio por código. Ajustável se o caixa trocar de peça mais rápido. */
export const JANELA_REPETICAO_MS = 1500;

export interface PortaoLeitura {
  /** `agora` é injetado para o comportamento ser testável sem relógio real. */
  permitir(codigo: string, agora: number): boolean;
  limpar(): void;
}

export function criarPortaoLeitura(janelaMs: number = JANELA_REPETICAO_MS): PortaoLeitura {
  const ultimaLeitura = new Map<string, number>();

  return {
    permitir(codigo, agora) {
      const anterior = ultimaLeitura.get(codigo);
      if (anterior !== undefined && agora - anterior <= janelaMs) return false;

      ultimaLeitura.set(codigo, agora);
      return true;
    },

    limpar() {
      ultimaLeitura.clear();
    },
  };
}
